// Generated file - do not change manually!
/**
 * Types for the placement of message Popover control.
 */
export var PopoverVerticalAlign;
(function (PopoverVerticalAlign) {
    /**
     * Popover will be placed at the bottom of the reference control.
     */
    PopoverVerticalAlign["Bottom"] = "Bottom";
    PopoverVerticalAlign["Center"] = "Center";
    /**
     * Popover will be streched
     */
    PopoverVerticalAlign["Stretch"] = "Stretch";
    /**
     * Popover will be placed at the top of the reference control.
     */
    PopoverVerticalAlign["Top"] = "Top";
})(PopoverVerticalAlign || (PopoverVerticalAlign = {}));
